import React from "react";
import RBS from "@retter/sdk";

export interface IThisProjectContext {
    thisRbsSdk?: RBS
}

export let ThisProjectContext: React.Context<IThisProjectContext> = React.createContext<IThisProjectContext>({})